/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Serializer for the outgoing PlannerView POST response slot data.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PlannerCalendarViewResponse { 
    appointmentResourceId: number;
    startDate: string;
    endDate: string;
    therapistId: number;
    therapistName: string;
    appointmentTypeId?: number | null;
    practiceName?: string | null;
    utilizationPercent?: number | null;
}
export const PlannerCalendarViewResponse_appointmentResourceId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerCalendarViewResponse_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerCalendarViewResponse_endDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerCalendarViewResponse_therapistId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerCalendarViewResponse_therapistName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerCalendarViewResponse_appointmentTypeId_Validators: ValidatorFn[] =
    [ ];

export const PlannerCalendarViewResponse_practiceName_Validators: ValidatorFn[] =
    [ ];

export const PlannerCalendarViewResponse_utilizationPercent_Validators: ValidatorFn[] =
    [  Validators.min(-100000), Validators.max(100000),];


